module.exports = {"id":"190674","name":"Benjamin André","rating":"77","photo":"./data/images/photos/1/190674.png","club":{"name":"Stade Rennais","logo":"./data/images/clubs/StadeRennais.png"},"positions":["MC","MDC","MG"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BenjaminAndre0.json
// module id = 565
// module chunks = 0